<template>
  <div class="app-container">
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick" class="cardTabs">
       <el-tab-pane label="点名日志" name="list">
        <list ref="list">
          <template slot="toolbar-right">
            <el-button size="mini" type="primary" plain @click="onExport('list')" v-if="!isMB">导出</el-button>
          </template>
          <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="80">
              <template slot-scope="{row}">
                <el-button type="text" v-if="row.AttendanceId!=0" @click="details(row)">查看</el-button>
                <el-button type="text" v-else-if="row.Report==0" @click="toReport(row)">报备</el-button>
                <el-button type="text" v-else-if="row.Report==1" @click="unReport(row)">取消报备</el-button>
              </template>
            </el-table-column>
          </template>
        </list>
      </el-tab-pane>
      <el-tab-pane label="考勤员未点名" name="student">
        <student ref="student">
          <template slot="toolbar-right">
            <el-button size="mini" type="primary" plain @click="onExport('student')" v-if="!isMB">导出</el-button>
          </template>
        </student>
      </el-tab-pane>
      <el-tab-pane label="教师未点名" name="teacher">
        <teacher ref="teacher">
          <template slot="toolbar-right">
            <el-button size="mini" type="primary" plain @click="onExport('teacher')" v-if="!isMB">导出</el-button>
          </template>
        </teacher>
      </el-tab-pane>
    </el-tabs>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" />
    <import-dialog ref="importDialog" @upload-success="reload" />
    <import-pic-dialog ref="importPicDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/at/logs/list";
import student from "@/components/at/logs/student";
import teacher from "@/components/at/logs/teacher";
import detailsDialog from "@/components/at/logs/detailsDialog";
import editDialog from "@/components/st/student/editDialog";
import importDialog from "@/components/st/student/importDialog";
import importPicDialog from "@/components/st/student/importPicDialog";

export default {
  name: "logs",
  mixins: [curdMixins],
  components: {
    list,
    student,
    teacher,
    detailsDialog,
    editDialog,
    importDialog,
    importPicDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      api: require("@/api/at/attendance").default,
      tabName: "list"
    };
  },
  methods: {
    onExport(name) {
      this.$refs[name].onExport();
    },
    details(row) {
      this.$refs.detailsDialog.open().then((that) => {
        that.getData(row);
      });
    },
    toReport(row) {
      this.$confirm("确认报备\"" + row.ClassName + " " + this.$commonJs.toDateString(row.AttendanceDate) + " "  + row.SectionName + " "  + row.Subject + "\"这节课吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.report(row.TimetableDtsId).then(res => {
            if(res.Code==0) {
              this.reload();
              this.$message.success(res.Msg);
            } else {
              this.$message.error(res.Msg);
            }
          })
        })
        .catch(() => {});
    },
    unReport(row) {
      this.$confirm("确认取消报备\"" + row.ClassName + " " + this.$commonJs.toDateString(row.AttendanceDate) + " "  + row.SectionName + " "  + row.Subject + "\"这节课吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.unReport(row.TimetableDtsId).then(res => {
            if(res.Code==0) {
              this.reload();
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.Msg);
            }
          })
        })
        .catch(() => {});
    },
    handleClick() {
      if(this.tabName == 'list') {
        this.reload();
      } else if(this.tabName == 'student') {
        this.$refs.student.begin();
      } else {
        this.$refs.teacher.begin();
      }
    },
  },
};
</script>
<style scoped></style>